import React from 'react';
import {Form} from 'FW/Models/Form';
import {Responsive, WidthProvider as widthProvider} from 'react-grid-layout';
const ResponsiveReactGridLayout = widthProvider(Responsive);
import _ from 'underscore';
var clone = require('clone');
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import config from 'config';
import './Form.scss';
import 'jquery-serializejson';
import InlineEditableElement from 'Components/InlineEditableElement';
import Loading from '../../../CommonElements/Loading';
import StandardPaymentForm from 'FrontEnd/StandardPaymentForm';
import creditCardRegex from 'credit-card-regex';
import {TpegUrls} from '../../../FW/Models/TpegUrl';
let Validator;

class FormSection extends React.Component {
  constructor(props) {
    super(...arguments);

    this._form = React.createRef();
    let form = Form.findOrCreate({id: props.section.prop('form_id')});
    let qs = new URLSearchParams(window.location.search);

    let hash = window.location.hash;
    this.state = {
      form: form,
      fields: form.get('fields'),
      breakpoint: 'lg',
      active: false,
      layouts: form.childLayouts,
      submitSuccess: hash.indexOf('#payment_confirmed')  >= 0,
      showCancel: qs.has('showCancel'),
      loadingText: 'Submitting Form...'
    };
    this.formClicked = this.formClicked.bind(this);
    this.onLayoutChange = this.onLayoutChange.bind(this);
    this.onStart = this.onStart.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.renderHeight = this.renderHeight.bind(this);
    this.getTabOrder = this.getTabOrder.bind(this);
    this.addButtonToSection = this.addButtonToSection.bind(this);
    this.setWasChanged = this.setWasChanged.bind(this);
    if (FW.inEditor()) {
      this.addButtonToSection();
    }

    if (this.isTpeg() && FW.store.get('user')) {
      let urls = new TpegUrls();
      urls.addQuery({
        user_id: FW.store.get('user').get('id')
      });
      urls.fetch().then((r) => {
        if (r.data.length > 0) {
          this.setState({
            hasTpeg: true
          });
        }
      });
    }
  }

  addButtonToSection() {
    let section = this.props.section;
    let user = window.parent.FW.store.get('user')
      ? window.parent.FW.store.get('user')
      : null;
    if (user && user.may('view_form_responses', this.state.form)) {
      section._editButtons = [
        {
          title: 'View Responses',
          class: 'glyphicon-eye-open',
          type: 'btn-default',
          action: () => {
            window.open('/admin/forms/' + this.state.form.get('id'));
          }
        },
        {
          title: 'Embed Link',
          class: 'glyphicon-link',
          type: 'btn-default',
          action: () => {
            window.parent.swal.fire({
              title: 'Embed Code',
              html: '<textarea  onclick="this.focus();this.select();" style="width: 100%;"><iframe src="https://' + window.location.hostname + '/forms/' + this.state.form.get('id') + '/embed" style="width: 100%; height: 100%; border: 0;" frameborder="0" readonly="readonly"></iframe></textarea>'
            });
          }
        }
      ];
    }
  }

  componentDidMount() {
    let self = this;
    if (this.props.editor) {
      $('body').on('click', event => {
        let mode = this.props.editor.modes.activeMode;
        if (
          mode.form === this.state.form &&
          !$(event.target).is('.fw-form *')
        ) {
          event.stopPropagation();
          event.preventDefault();
          window.parent.FW.editor.setMode('default');
          self.setState({
            active: false
          });
        }
      });
    }

    // detect IP and set it
    const ipInfo = Helper.getWithExpiry('fw_form_state');
    if (ipInfo === null) {
      const detectIp = async () => {
        const states = Helper.getStatesArray();
        $.getJSON('/api/v1/forms/get-state', (data) => {
          const state = _.invert(states)[data.name];
          Helper.setWithExpiry('fw_form_state', state, 3600);
          this.setState({state: state});
        });
      }
      if (this.state.form.get('tax_state') !== '' && typeof this.state.form.get('tax_state') !== 'undefined' && this.state.form.get('tax_state') !== null) {
        detectIp();
      }
    } else {
      this.setState({state: ipInfo});
    };

    import('validatorjs').then((mod) => {
      Validator = mod.default;
    });

    if (FW.inEditor()) window.parent.FW.editor.addType('form', this.state.form);
    this.state.form.on(
      'sync',
      () => {
        this.setState({
          layouts: this.state.form.childLayouts
        });
      },
      this
    );

    this.state.fields.on(
      'update',
      () => {
        this.setState({
          layouts: this.state.form.childLayouts
        });
      },
      this
    );
  }

  componentWillUnmount() {
    $('body').off('click');
    this.state.form.off(null, null, this);
    this.state.fields.off(null, null, this);
  }

  setWasChanged() {
    if (
      this.props.editor &&
      this.props.editor.mode.action === 'arrangeSection'
    ) {
      this.wasChanged = true;
    }
  }

  onLayoutChange(layout) {
    this.stop = true;
    window.parent.$u.loading(false, 'Saving Field Order...');
    this.setState({loading: true});
    if (
      this.props.editor &&
      this.props.editor.modes.activeMode.currentAction === 'arrangeFields'
    ) {
      let cb = _.clone(this.state.form.prop('custom_breakpoints') || {});
      cb[this.state.breakpoint] = true;
      this.state.form.prop('custom_breakpoints', cb);
      let allLayouts = clone(this.state.layouts);
      allLayouts[this.state.breakpoint] = layout;
      _.each(allLayouts[this.state.breakpoint], f => {
        let id = f.i.replace('field-', '');
        let field = this.state.fields.get(id);
        let l = field.prop('grid_layouts') || {};
        l[this.state.breakpoint] = f;
        field.prop('grid_layouts', l);
      });
      this.state.fields.save().then(() => {
        window.parent.$u.loading(true);
        this.setState({loading: false, loadingText: 'Submitting Form...'});
      });
      this.setState({
        layouts: this.state.form.childLayouts
      });
    }
  }

  formClicked(e) {
    if (FW.inEditor()) {
      let mode = this.props.editor.modes.activeMode;
      if (mode.form !== this.state.form || mode.field) {
        e.stopPropagation();
        e.preventDefault();
        this.props.editor.setMode('editForm', 'editForm', {
          form: this.state.form
        });
        this.setState({
          active: true
        });
      }
    }
  }

  fieldClicked(field, e) {
    if (this.props.editor && this.state.active && !this.wasChanged && this.props.editor.modes.activeMode.currentAction !== 'arrangeFields' && FW.skPackageMatch('forms')) {
      e.stopPropagation();
      e.preventDefault();
      let editor = this.props.editor;
      editor.setMode('editForm', 'editField', {field: field});
      this.forceUpdate();
    }
  }

  onStart(a, b, c, d, e) {
    this.wasChanged = false;
  }

  isTpeg() {
    let fields = this.state.form.get('fields');
    return typeof fields.findWhere({field_type: 'TpegTitle'}) !== 'undefined';
  }

  isSubscription() {
    if (this._form.current) {
      let formData = new FormData(this._form.current);
      let fields = this.state.form.get('fields');
      let subscriptionField = fields.findWhere({field_type: 'Subscription'});
      if (subscriptionField) {
        return formData.get('form-field-' + subscriptionField.get('id')) === 'subscription';
      }
    }
    return false;
  }

  notifyParentFrame(){
    window.parent.postMessage('fw-form-submit-success', '*');
  }

  async submitForm(nowOrLater, e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      loading: true
    });

    let formData = new FormData(this._form.current);
    let validationData = $(this._form.current).serializeJSON({
      skipFalsyValuesForTypes: ['string'],
      parseAll: true
    });
    let token =  await this.props.googleReCaptchaProps.executeRecaptcha('submit_form');

    let url = '/form/' + this.state.form.get('id');
    let fields = this.state.form.get('fields');
    let uploadFields = fields.where({field_type: 'Upload'});
    let paymentNotes = fields.findWhere({field_type: 'Notes'}) || fields.findWhere({field_type: 'NotesRadio'});
    let subscriptionField = fields.findWhere({field_type: 'Subscription'});
    let donationField = false;
    fields.each((field) => {
      if (field.get('field_type') === 'Input' && field.prop('currencyField') && field.prop('donationField')) {
        donationField = field;
      }
    });

    formData.append('total_amount', this.state.form.getSelectedValue());
    formData.append('payment_time', nowOrLater);
    formData.append('g-recaptcha-response', token);

    let subValue = 'onetime';
    if (subscriptionField) {
      subValue = formData.get('form-field-' + subscriptionField.get('id'));
    }

    let rules = {};
    fields.each(field => {
      if (field.rules) {
        rules['form-field-' + field.get('id')] = field.rules;
      }
    });

    uploadFields.forEach(field => {
      let file = formData.get('form-field-' + field.get('id'));
      if (file.name !== '') {
        validationData['form-field-' + field.get('id')] = true;
      }
    });

    if (this.state.paymentInformation && nowOrLater === 'now') {
      validationData.paymentInformation = this.state.paymentInformation;
      validationData.paymentInformation.ccNumber = validationData.paymentInformation.ccNumber.replace(/\s/g, '');
      validationData.paymentInformation.ccValid = creditCardRegex({exact: true}).test(this.state.paymentInformation.ccNumber);
      _.each(validationData.paymentInformation, (value, key) => {
        formData.set('paymentInformation[' + key + ']', value);
      });
    }

    let paymentRules = this.state.form.get('payment_processor') === 'AuthorizeNet' && nowOrLater === 'now' ? {
      paymentInformation: {
        ccNumber: 'required',
        cvv: 'required|numeric',
        ccName: 'required',
        ccValid: 'accepted'
      }
    } : {};

    let validator = new Validator(validationData, {
      ...rules,
      ...paymentRules
    }, {
      'required.paymentInformation.ccNumber': 'The credit card number is required',
      'required.paymentInformation.cardName': 'The card name is required',
      'accepted.paymentInformation.ccValid': 'The credit card number is invalid'
    });
    let attributeNames = {};
    fields.each(field => {
      attributeNames['form-field-' + field.get('id')] = field.get('title');
    });
    validator.setAttributeNames(attributeNames);

    if (validator.passes()) {
      const confirmationPage = this.state.form.get('confirmation_page') ? this.state.form.get('confirmation_page') : window.location.href + '#payment_confirmed';
      formData.append('confirmation_page', confirmationPage);
      $.ajax({
        url: url,
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        enctype: 'multipart/form-data',
        complete: r => {
          if (r.responseJSON.success) {
            if (r.responseJSON.redirect_url) {
              setTimeout(() => {
                window.location.href = r.responseJSON.redirect_url;
              }, 1500);
              return;
            }
            // send to paypal if we need to
            if (
              (this.state.form.getSelectedValue() > 0 || formData.get('subscription-amount') > 0) &&
              this.state.form.get('payment_processor') ===
                'PayPalPaymentsStandard' &&
              nowOrLater === 'now'
            ) {
              let details = this.state.form.get('payment_processor_details');
              const donationInfo = donationField ? {
                item_name: donationField.prop('donationTitle'),
                amount: this.state.form.getSelectedValue()
              } : {};
              let payPalData = {
                cmd: donationField ? '_donations' : (subValue === 'subscription' ? '_xclick-subscriptions' : '_cart'),
                ...donationInfo,
                upload: 1,
                business: details.email,
                return: confirmationPage,
                custom: this.state.form.get('title') + ' Response: ' + r.responseJSON.id,
                no_shipping: 1,
                currency_code: details.currency_code ?? 'USD',
                notify_url:
                  'https://' + document.domain + config.API_ROOT + '/paypal/ipn'
              };

              if (subValue === 'onetime') {
                const details = this.state.form.get("payment_processor_details") || {};
                let paymentNotesText = '';
                if (paymentNotes && typeof paymentNotes.get('options') !== 'undefined' && paymentNotes.get('options').length > 0) {
                  paymentNotesText = ' - Notes: ' + paymentNotes.get('options').findWhere({id: formData.get('form-field-' + paymentNotes.get('id'))}).get('name');
                } else {
                  paymentNotesText = paymentNotes && formData.get('form-field-' + paymentNotes.get('id')) ? ' - Notes: ' + formData.get('form-field-' + paymentNotes.get('id')) : '';
                }
                payPalData.item_name_1 = (details.checkout_description || 'Selected Items') + paymentNotesText;
                payPalData.amount_1 = this.state.form.getSelectedValue();
                if (this.state.state === this.state.form.get('tax_state')) {
                  payPalData.tax_1 = this.state.form.getTaxValue();
                }
                _.each(this.state.form.getSurchargeFields(), (v, i) => {
                  payPalData['item_name_' + (i+2)] = v.prop('surcharge_title');
                  payPalData['amount_' + (i+2)] = v.getSurchargeValue();
                  payPalData['tax_' + (i+2)] = 0;
                });
                if (this.state.form.chargeHandlingFee()) {
                  const total = this.state.form.getTotalValue(this.state.state === this.state.form.get('tax_state'));
                  payPalData.handling_cart = 0.30 + (total * 0.022);
                }
              } else if (subValue === 'subscription') {
                const altSubAmount = formData.get('subscription-amount');
                if (typeof altSubAmount !== 'undefined') {
                  payPalData.item_name = subscriptionField.prop('subscription_title');
                  payPalData.a1 = subscriptionField.prop('no_trial_period') ? parseFloat(altSubAmount) : this.state.form.getTotalValue();
                  payPalData.p1 = formData.get('subscription-period-value') !== 'W' ? formData.get('subscription-period-value') : 1;
                  payPalData.t1 = formData.get('subscription-period-value') === 'W' ? 'W' : 'M';
                }
                payPalData.a3 = altSubAmount ? parseFloat(altSubAmount) : this.state.form.getTotalValue();
                payPalData.p3 = formData.get('subscription-period-value') !== 'W' ? formData.get('subscription-period-value') : 1;
                payPalData.t3 = formData.get('subscription-period-value') === 'W' ? 'W' : 'M';
                payPalData.src = 1;
                payPalData.sra = 1;
                payPalData.no_note = 1;
              }

              var form = document.createElement('form');
              form.setAttribute('method', 'post');
              form.setAttribute('action', config.PAYPAL_URL);
              _.each(payPalData, (v, k) => {
                var hiddenField = document.createElement('input');
                hiddenField.setAttribute('type', 'hidden');
                hiddenField.setAttribute('name', k);
                hiddenField.setAttribute('value', v);
                form.appendChild(hiddenField);
              });
              document.body.appendChild(form);
              form.submit();
            } else {
              if (this.state.form.get('confirmation_page')) {
                window.location.href = confirmationPage;
              } else {
                this.notifyParentFrame();
                this.setState({
                  submitSuccess: true,
                  loading: false,
                  paid: r.responseJSON.paid
                });
                let el = this.props.section.element();
                $('body').animate({
                  scrollTop: el.offset().top - 70
                });
              }
            }
          } else {
            this.setState({
              errors: r.responseJSON.errors,
              loading: false
            }, () => {
              if (r.responseJSON.error) {
                swal.fire('Error', r.responseJSON.error + ' ', 'error');
              }
            });
          }
        }
      });
    } else {
      this.setState({
        errors: validator.errors.all(),
        loading: false
      });
    }
  }

  renderHeight(field, size) {
    let layouts = clone(this.state.layouts);
    let i = _.findIndex(layouts[this.state.breakpoint], {
      i: 'field-' + field.get('id')
    });
    let fieldLayout = layouts[this.state.breakpoint][i];
    if (fieldLayout) {
      let neededHeight = Math.ceil(size.height / 30);
      if (fieldLayout.h < neededHeight) {
        layouts[this.state.breakpoint][i].h = neededHeight;
        this.setState({
          layouts: layouts
        });
      }
    }
  }

  getTabOrder() {
    let layouts = clone(this.state.layouts[this.state.breakpoint]);
    let tabOrder = {};
    _(layouts)
      .chain()
      .sortBy(layout => {
        return layout.x;
      })
      .sortBy(layout => {
        return layout.y;
      })
      .each((layout, i) => {
        let id = layout.i.replace('field-', '');
        tabOrder[id] = i + 1;
      });
    return tabOrder;
  }

  breakpointChange = v => {
    console.log('changing breakpoint to: ', v);
    this.setState({breakpoint: v});
  };

  paymentFormChanged = (v) => {
    this.setState({
      paymentInformation: v
    });
  };

  scrollNow = (step) => {
    const scrollY = $(window).scrollTop();
    window.scrollTo(0, scrollY + step);
    clearInterval(this.scrollInterval);
    if (!this.stop) {
      this.scrollInterval = setInterval(() => {
        this.scrollNow(step);
      }, 20);
    }
  }

  onDrag = (layout, oldItem, newItem, placeholder, e) => {
    if (e.clientY < 150) {
      this.stop = false;
      this.scrollNow(-4)
      return;
    }

    if (e.clientY > ($(window).height() - 150)) {
      this.stop = false;
      this.scrollNow(4)
      return;
    }

    this.stop = true;
  }

  render() {
    //For creating form templates
    //console.log(this.state.form.serializeAttributes());
    let form = this.state.form;
    let mode = this.props.editor ? this.props.editor.modes.activeMode : {};
    let activeField = mode.field;
    let formClass =
      'fw-form ' + (mode.form === this.state.form ? 'highlight' : '');
    let tabOrder = this.getTabOrder();
    let lastTab = _.max(_.values(tabOrder));
    let processorDetails = form.get('payment_processor_details') || {};
    let processor = form.get('payment_processor');

    let arrangable =
      typeof this.props.editor !== 'undefined' &&
      this.props.editor.modes.activeMode.currentAction === 'arrangeFields';

    let orderId = (this.props.section.get('group') && this.props.section.get('group').get('order_id') ? this.props.section.get('group').get('order_id') : '0');
    let groupOrder = '10' + orderId.toString();
    let sectionOrder = '0';
    if (this.props.section.get('group')) {
      this.props.section.get('group').element().find("[data-fw-model='PageSection']").each((f, v) => {
        if ($(v).data('id') === this.props.section.get('id')) {
          sectionOrder = f;
        }
      });
    }
    let tabPrefix = groupOrder.toString() + sectionOrder.toString();

    const amountTaxed = this.state.form.get('tax_rate') && !this.isSubscription() && this.state.state === this.state.form.get('tax_state');

    let selectedValue = form.getSelectedValue();
    let totalValue = form.getTotalValue(amountTaxed);
    let taxValue = form.getTaxValue();
    let surchargeValue = form.getTotalSurcharge();
    let lastTabIndex = '0';

    const hideForm = form.get('at_limit') || this.state.hasTpeg;
    let formEl = (
      <form className="finalweb-form" data-form-id={form.get('id')} ref={this._form} style={{opacity: hideForm ? 0.5 : 1, pointerEvents: hideForm ? 'none' : null}}>
        <ResponsiveReactGridLayout
          className="layout"
          rowHeight={30}
          isDraggable={arrangable === true}
          isResizable={arrangable === true}
          breakpoints={{lg: 900, sm: 370, xs: 0}}
          onBreakpointChange={this.breakpointChange}
          cols={{lg: 12, sm: 6, xs: 2}}
          layouts={this.state.layouts}
          onDragStop={this.onLayoutChange}
          onResizeStop={this.onLayoutChange}
          onLayoutChange={this.setWasChanged}
          onDragStart={this.onStart}
          onDrag={this.onDrag}
          containerPadding={[0, 0]}
          margin={[0, 0]}
          onResizeStart={this.onStart}
        >
          {form.get('fields').map((field, i) => {
            let tabIndex = tabPrefix + ('000' + tabOrder[field.get('id')]).slice(-4);
            lastTabIndex = tabIndex;
            let Comp = field.getReactComponent();
            let classes =
              'form-group fw-form-field ' +
              (activeField === field ? 'highlight' : '') +
              ' ' +
              (field.prop('required') ? 'required' : '');
            return <div
              data-field-id={field.get('id')}
              data-fw-model="FormField"
              className={classes}
              key={`field-${field.get('id')}`}
              onClick={this.fieldClicked.bind(this, field)}
            >
              <Comp
                onChange={() => {this.forceUpdate()}}
                fieldIndex={i}
                field={field}
                errors={this.state.errors}
                tabIndex={tabIndex}
                finishedRendering={this.renderHeight}
              />
            </div>;
          })}
        </ResponsiveReactGridLayout>

        {processor && processor !== 'PayPalPaymentsStandard' && processor !== 'Square' && processor !== 'Stripe' && selectedValue > 0 ? <div>
          <StandardPaymentForm onChange={this.paymentFormChanged} />
        </div> : null}

        <div style={{textAlign: 'center', width: '100%', clear: 'both'}}>
          {selectedValue > 0 ? (
            <div style={{width: '100%', marginTop: 10}}>
              <p className="lead" style={{marginBottom: 0}}>
                <strong>Subtotal:</strong> $
                {parseFloat(selectedValue).toFixed(2)}
              </p>
              {amountTaxed ? <div>
                <p className="lead" style={{marginBottom: 0}}>
                  <strong>Tax:</strong> $
                  {parseFloat(taxValue).toFixed(2)}
                </p>
              </div> : null}
              {this.state.form.hasSurcharges() ? <div>
                <p className="lead" style={{marginBottom: 0}}>
                  <strong>Surcharges{this.state.form.surchargeOnlineOnly() ? ' (for online payments)' : ''}:</strong> $
                  {parseFloat(surchargeValue).toFixed(2)}
                </p>
              </div> : null}
              <p className="lead">
                <strong>Amount Due:</strong> ${parseFloat(totalValue).toFixed(2)}
              </p>
            </div>
          ) : null}

          <div
            style={{
              margin: 'auto',
              width: this.state.breakpont !== 'xs' ? 304 : 164,
              marginBottom: 10,
              marginTop: 10
            }}
          >
          </div>
          {this.state.errors ? (
            <div style={{color: '#ff0000', fontWeight: 'bold', marginBottom: 10}}>
              {typeof this.state.errors === 'boolean' ? (
                <p>
                  There was a problem submitting your form. Please try again.
                </p>
              ) : (
                <p>
                  There were some problems with your input.
                  <br />
                  Please check your information and try again.
                </p>
              )}
            </div>
          ) : null}
          <div>
            {form.get('submission_limit_details') && form.get('submission_limit_details').display_available ? <div style={{fontSize: '1.5rem', marginTop: 15, marginBottom: 15}}>
              {form.get('spots_remaining')} Available
            </div> : null}
            {processor ? (
              <div>
                {this.state.showCancel ? <span
                      className="btn btn-default"
                      onClick={this.notifyParentFrame}
                    >
                  Cancel
                </span> : null}&nbsp;
                <button
                  type="submit"
                  data-cy="submit-form"
                  tabIndex={parseInt(lastTabIndex, 10) + 2}
                  className="btn btn-primary"
                  onClick={this.submitForm.bind(this, selectedValue > 0 ? 'now' : 'later')}
                  disabled={FW.inEditor()}
                >
                  {selectedValue > 0 ? 'Submit and Pay' : (form.prop('submit_text') ? form.prop('submit_text') : 'Submit')}
                </button>
                {processorDetails.allow_delayed_payment &&
                selectedValue > 0 ? (
                  <button
                    type="submit"
                    tabIndex={lastTab + 3}
                    className="btn btn-default"
                    data-cy="submit-form"
                    onClick={this.submitForm.bind(this, 'later')}
                    disabled={FW.inEditor()}
                  >
                    Pay Later
                  </button>
                ) : null}
              </div>
            ) : (
              <div>
                {this.state.showCancel ? <span
                      className="btn btn-default"
                      onClick={this.notifyParentFrame}
                    >
                  Cancel
                </span> : null}&nbsp;
                <button
                  type="submit"
                  tabIndex={lastTab + 2}
                  className="btn btn-primary"
                  data-cy="submit-form"
                  onClick={this.submitForm.bind(this, 'later')}
                  disabled={FW.inEditor()}
                >
                  {selectedValue > 0
                    ? 'Submit and Pay Later'
                    : (form.prop('submit_text') ? form.prop('submit_text') : 'Submit')}
                </button>
              </div>
            )}
            <div style={{color: '#bec0c1', fontSize: 12, maxWidth: 300, margin: 'auto', padding: 5}} className="captcha-message">
              This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </div>
          </div>
        </div>
      </form>
    );

    const size = this.props.size ? this.props.size : {};

    const formOverlayStyle = {
      zIndex: 1,
      position: 'relative',
      marginBottom: -size.height,
      background: 'rgba(0, 0, 0, 0.5)',
      color: 'white',
      width: '100%',
      height: size.height,
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: 7,
      fontSize: this.state.hasTpeg ? 20 : 40,
      lineHeight: size.height + 'px',
      textAlign: 'center'
    };

    return (
      <div
        className={formClass}
        data-fw-model="Form"
        onClick={this.formClicked}
        ref={e => (this._el = e)}
        style={{padding: 10}}
      >
        {this.state.loading ? <div style={{transform: 'translate3d(0,0,0)', height: '100vh', width: '100%', position: 'fixed', top: 0, left: 0, right: 0}}>
          <Loading fullScreen backgroundColor="rgba(255,255,255,0.5)" wheel={true} text={this.state.loadingText} />
        </div> : null}
        {!this.state.submitSuccess ? (
          <div>
            <div style={{opacity: this.state.loading ? 0.5 : 1, pointerEvents: this.state.loading ? 'none': null}}>
              {form.get('at_limit') ? <div style={formOverlayStyle}>
                Registration is Full
              </div> : this.state.hasTpeg ? <div style={formOverlayStyle}>
                A site is already linked to this user.
              </div> : null}
              {formEl}
            </div>
          </div>
        ) : (
          <div>
            {form.get('confirmation_message') ? (
              <InlineEditableElement html={form.get('confirmation_message')} />
            ) : (
              <p
                className="lead"
                style={{textAlign: 'center', paddingTop: 75, paddingBottom: 75}}
              >
                Your submission has been received{this.state.paid ? ' and your payment was successful.' : ''}.
              </p>
            )}
            {form.get('confirmation_code') ? (
              <iframe
                style={{display: 'none'}}
                src={`${config.API_ROOT}/forms/${form.get(
                  'id'
                )}/confirmation-code`}
              ></iframe>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

const RecaptchaCommentForm = withGoogleReCaptcha(FormSection);

export default function (props){
  return <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA3_PUBLIC_KEY}>
    <RecaptchaCommentForm {...props} />
  </GoogleReCaptchaProvider>
}
